module.exports = __webpack_public_path__ + "static/img/Inspection11.15c2101d.png";